module.exports = __webpack_public_path__ + "img/261-3dc297.png";